import React, { useState, useEffect, useRef } from "react";

const AnimatedDiv = ({ children, animate, onClose }) => {
  const [dragY, setDragY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [mounted, setMounted] = useState(false);
  const startY = useRef(0);

  useEffect(() => {
    // Trigger entry animation
    const timer = setTimeout(() => setMounted(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const handleTouchStart = (e) => {
    startY.current = e.touches[0].clientY;
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    const currentY = e.touches[0].clientY;
    const diff = currentY - startY.current;
    // Only allow dragging downwards
    if (diff > 0) {
      setDragY(diff);
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    // If dragged down more than 120px, close it
    if (dragY > 120) {
      setDragY(500); // Visual slide down
      setTimeout(() => {
        if (onClose) onClose();
      }, 200);
    } else {
      setDragY(0);
    }
  };

  // Base transition style
  const transition = isDragging
    ? "none"
    : "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)";

  return (
    <div
      className="fixed z-[53] left-0 w-screen bg-white pb-8 border-t border-gray-100 bottom-0 sm:bottom-16 rounded-t-[2.5rem] shadow-[0_-10px_40px_rgba(0,0,0,0.1)]"
      style={{
        transform: `translateY(${!mounted ? "100%" : `${dragY}px`})`,
        transition: transition,
      }}
    >
      {/* Drag Handle */}
      <div
        className="w-full pt-4 pb-6 flex justify-center cursor-ns-resize touch-none select-none"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onClick={() => {
          // Optional: clicking the handle also closes it
          setDragY(500);
          setTimeout(() => onClose && onClose(), 200);
        }}
      >
        <div className="h-1.5 w-14 bg-gray-200 rounded-full shadow-inner"></div>
      </div>

      <div className="overflow-y-auto max-h-[70vh] px-4">{children}</div>
    </div>
  );
};

export default AnimatedDiv;
